module.exports = __webpack_public_path__ + "img/img-3-15mobile.e36cbd9c.webp";